const BicecFrontoffice = {
  id: "BicecWebFrontofficeApplication",
  product: "FRONTOFFICE",
  api: {
    baseUrl:
      window.__RUNTIME_CONFIG__.BASE_URL || "https://m.bipay-test.bicec.com",
  },
  phone: {
    countryCode: "237",
    countryPrefix: "cm",
  },
  theme: {
    primaryColor: "245 138 42",
    secondaryColor: "73 30 6",
  },
  brand: {
    name: window.__RUNTIME_CONFIG__.APP_NAME || "BIPAY",
    bankCode: window.__RUNTIME_CONFIG__.CODE_BANQUE || "10001",
    bankName: "BICEC",
  },
  authImageOptions: {
    objectFit: "cover",
    overlay: "bg-secondaryColor/30",
  },
  assets: {
    dashboardPattern: "/images/bicec/pattern_bicec.png",
    logo: "/images/bicec/bpay.png",
    logoWide: "/images/bicec/bpay.png",
    loginImage: "/images/bicec/login-image.jpg",
    favicon: "/images/bicec/favicon.ico",
    logoSize: 120,
  },
  links: {
        reclamationUrl: "https://www.bicec.com/reclamation/",
  },
  features: {
    captcha: true,
  },
};

const FigecFrontoffice = {
  id: "FigecFrontoffice",
  product: "FRONTOFFICE",
  api: {
    baseUrl:
      window.__RUNTIME_CONFIG__.BASE_URL || "http://apps.figec-sa.cm:8767",
  },
  phone: {
    countryCode: "237",
    countryPrefix: "cm",
  },
  theme: {
    primaryColor: "3 76 46",
    secondaryColor: "193 208 29",
  },
  brand: {
    name: window.__RUNTIME_CONFIG__.APP_NAME || "FIGEC",
    bankCode: window.__RUNTIME_CONFIG__.CODE_BANQUE || "10001",
    bankName: "FIGEC",
  },
  authImageOptions: {
    objectFit: "cover",
    overlay: "bg-black/30",
  },
  assets: {
    dashboardPattern: "/images/bicec/figec_bicec.png",
    logo: "/images/figec/figec-green.png",
    logoWide: "/images/figec/figec-green.png",
    loginImage: "/images/figec/bg.jpg",
    favicon: "/images/figec/favicon.ico",
    logoSize: 120,
  },
  links: {
  },
  features: {
    captcha: false,
  },
};

const CbcFrontoffice = {
  id: "CbcFrontoffice",
  product: "FRONTOFFICE",
  api: {
    baseUrl:
      window.__RUNTIME_CONFIG__.BASE_URL || "hhttps://m.bipay-test.bicec.com",
  },
  phone: {
    countryCode: "237",
    countryPrefix: "cm",
  },
  theme: {
    primaryColor: "208 179 53",
    secondaryColor: "0 0 0",
  },
  brand: {
    name: window.__RUNTIME_CONFIG__.APP_NAME || "Speedoh",
    bankCode: window.__RUNTIME_CONFIG__.CODE_BANQUE || "10001",
    bankName: "CBC",
  },
  authImageOptions: {
    objectFit: "cover",
    overlay: "bg-black/30",
  },
  assets: {
    dashboardPattern: "/images/bicec/figec_bicec.png",
    logo: "/images/cbc/cbc.png",
    logoWide: "/images/cbc/cbc.png",
    loginImage: "/images/cbc/bg.jpg",
    favicon: "/images/cbc/favicon.ico",
    logoSize: 120,
  },
  links: {},
  features: {
    captcha: true,
  },
};

const CceiFrontoffice = {
  id: "CceiFrontoffice",
  product: "FRONTOFFICE",
  api: {
    baseUrl: window.__RUNTIME_CONFIG__.BASE_URL || "http://41.79.49.227:8765",
  },
  phone: {
    countryCode: "240",
    countryPrefix: "gq",
  },
  theme: {
    primaryColor: "223 2 15",
    secondaryColor: "125 125 125",
  },
  brand: {
    name: window.__RUNTIME_CONFIG__.APP_NAME || "CCEI",
    bankCode: window.__RUNTIME_CONFIG__.CODE_BANQUE || "5001",
    bankName: "CCEI",
  },
  authImageOptions: {
    objectFit: "cover",
    overlay: "bg-black/30",
  },
  assets: {
    dashboardPattern: "/images/bicec/figec_bicec.png",
    logo: "/images/ccei/ccei.png",
    logoWide: "/images/ccei/ccei.png",
    loginImage: "/images/ccei/login.png",
    favicon: "/images/ccei/favicon.ico",
    logoSize: 230,
  },
  links: {},
  features: {
    accountUtilities: true,
    captcha: false,
  },
};

const IWOMIFrontoffice = {
  id: "IWOMIWebFrontOffice",
 api: {
    baseUrl:
      window.__RUNTIME_CONFIG__.BASE_URL || "https://m.bipay-test.bicec.com",
  },
  phone: {
    countryCode: "237",
    countryPrefix: "cm",
  },
  theme: {
    primaryColor: "80 122 56",
    secondaryColor: "80 122 56",
  },

  brand: {
    name: window.__RUNTIME_CONFIG__.APP_NAME || "IWOMI",
    bankCode: window.__RUNTIME_CONFIG__.CODE_BANQUE || "10001",
    bankEmail: "support@iwomi.com",
    bankName: "IWOMI TECHNOLOGIES",
  },
    authImageOptions: {
    objectFit: "cover",
    overlay: "bg-secondaryColor/10",
  },
  assets: {
    dashboardPattern: "/images/iwomi/pattern.png",
    logo: "/images/iwomi/logo.png",
    logoWide: "/images/iwomi/logoWide.png",
    loginImage: "/images/iwomi/image.png",
    favicon: "/images/iwomi/favicon.ico",
    logoSize: 180,
  },
  links: {},
  features: {
    captcha: true,
  },
};

export const CONFIGS = {
  [BicecFrontoffice.id]: BicecFrontoffice,
  [FigecFrontoffice.id]: FigecFrontoffice,
  [CbcFrontoffice.id]: CbcFrontoffice,
  [CceiFrontoffice.id]: CceiFrontoffice,
    [IWOMIFrontoffice.id]: IWOMIFrontoffice,
};

export { BicecFrontoffice, FigecFrontoffice, CbcFrontoffice, CceiFrontoffice, IWOMIFrontoffice };
